const formatNumber = (number: number | string | null | undefined, currency: string = 'USD') => {
  const num = Number(number);
  if (isNaN(num)) {
    throw new Error('Invalid number');
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(num);
};

export { formatNumber };
